<template>
  <div class="diagram-container" v-loading="loading">
    <div v-if="showOperation" class="diagram-attr">
      <div class="attr-content">
        <div class="default-attr">
          <div class="attr-item">
            <div class="title">图表类型</div>
            <div class="chart-type">
              <el-tooltip v-for="item in chartTypes" popper-class="chart-type-popper" effect="dark" :content="item.name"
                          placement="bottom" :key="item.basicUrl">
              <span class="chart-type-item" @mouseover.stop="hoverType = item.type" @mouseout.stop="hoverType = ''"
                    @click="selectChartType(item)">
                <img :src="getSrc(item)">
              </span>
              </el-tooltip>
            </div>
          </div>
          <el-collapse v-model="activeNames">
            <!-- 数据来源 -->
            <el-collapse-item name="1">
              <template slot="title">数据来源 <span
                class="open-collapse">{{ activeNames.includes('1') ? '收起' : '展开' }}</span> <i
                :class="getClass('1')"></i></template>
              <div class="attr-item">
                <div class="title">归档表</div>
                <public-combobox ref="selectMainTable" v-model="diagramParams.mainTableId" :options="tables"
                                 :clearable="false" :showOperationLength="10"></public-combobox>
              </div>
              <template v-if="diagramParams.reportType !== '6'">
                <div class="attr-item">
                  <div class="title">维度</div>
                  <div v-if="graphSetting.dimensionality.length > 0" class="selected-graph-list"
                       v-for="item in graphSetting.dimensionality" :key="item.id">
                    <div class="selected-item">
                      <span class="report-public-ellipsis" :title="item.name">{{ item.name }}</span>
                      <span class="operation-graph-container">
                        <span :class="['el-icon-edit', getColumnType(item) && 'disabled-icon-edit']" @click="editData(item, 'dimensionality')"></span>
                        <span class="el-icon-error" @click="deleteData(item, 'dimensionality')"></span>
                      </span>
                      <div v-if="item.id === editGraphObj.id && editGraphObj.type === 'dimensionality'"
                           class="edit-dialog-warp">
                        <div class="edit-dialog-title">日期单位</div>
                        <el-select v-model="editGraphObj.dimensionality.unit" placeholder="请选择">
                          <el-option label="季度" value="QUARTER"></el-option>
                          <el-option label="年" value="YEAR"></el-option>
                          <el-option label="年、月" value="MONTH"></el-option>
                          <el-option label="年、月、日" value="DAY"></el-option>
                        </el-select>
                        <div class="edit-dialog-footer">
                          <el-button @click="saveGraphAttr('dimensionality')" type="primary">保存</el-button>
                          <el-button @click="closeDialogWithGraph">取消</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="graph-attr-container">
                    <div
                      :class="['add-button', showTableColumnList === 1 && 'active-button', getDisabledBtn('dimensionality') && 'disabled-btn']"
                      @click.stop="openList('dimensionality')"><i class="el-icon-plus"></i>添加维度
                    </div>
                    <div v-if="showTableColumnList === 1" class="graph-attr-list">
                      <el-input class="dimensionSearch" v-model="dimensionSearch"></el-input>
                      <div class="list-content">
                        <div
                          :class="['graph-attr-item', getSelectClass(column, 'dimensionality') && 'select-item', getDisabledClass(column, 'dimensionality') && 'disabled-item']"
                          v-for="column in getDimensionalityColumn" :key="column.id"
                          @click.stop="selectItem('dimensionality', column)" :title="column.name">
                          <span>{{ column.name }}</span>
                          <i class="el-icon-check"></i>
                        </div>
                        <div v-if="columns.length === 0" class="none">暂无数据</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="attr-item">
                  <div class="title">指标</div>
                  <div v-if="graphSetting.norm.length > 0" class="selected-graph-list" v-for="item in graphSetting.norm"
                       :key="item.id">
                    <div class="selected-item">
                      <span class="report-public-ellipsis" :title="item.name">{{ item.name }}</span>
                      <span class="operation-graph-container">
                  <span class="el-icon-edit" @click="editData(item, 'norm')"></span>
                  <span class="el-icon-error" @click="deleteData(item, 'norm')"></span>
                </span>
                      <div v-if="item.id === editGraphObj.id && editGraphObj.type === 'norm'"
                           class="edit-dialog-warp graph-index-dialog">
                        <div class="edit-dialog-title">显示格式</div>
                        <el-select v-model="editGraphObj.norm.showType" placeholder="请选择">
                          <el-option label="默认" value="默认"></el-option>
                          <el-option label="显示千分位分隔符" value="显示千分位分隔符"></el-option>
                          <el-option label="显示百分比" value="显示百分比"></el-option>
                        </el-select>
                        <div class="edit-dialog-title">显示单位</div>
                        <el-select v-model="editGraphObj.norm.showUnit" placeholder="请选择">
                          <el-option label="请选择" value="请选择"></el-option>
                          <el-option label="元" value="元"></el-option>
                          <el-option label="万元" value="万元"></el-option>
                          <el-option label="件" value="件"></el-option>
                          <el-option label="%" value="%"></el-option>
                        </el-select>
                        <div class="edit-dialog-title">
                          <span>小数位数</span>
                          <el-tooltip content="填写者可选择小数位数，否则默认不限制" placement="top" class="tooltip">
                            <span class="el-icon-info"></span>
                          </el-tooltip>
                        </div>
                        <el-select v-model="editGraphObj.norm.decimalDigits" placeholder="请选择限制位数">
                          <el-option label="请选择" value="请选择"></el-option>
                          <el-option label="1" value="1"></el-option>
                          <el-option label="2" value="2"></el-option>
                          <el-option label="3" value="3"></el-option>
                          <el-option label="4" value="4"></el-option>
                          <el-option label="5" value="5"></el-option>
                        </el-select>
                        <div class="edit-dialog-footer">
                          <el-button @click="saveGraphAttr('norm')" type="primary">保存</el-button>
                          <el-button @click="closeDialogWithGraph">取消</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="graph-attr-container">
                    <div
                      :class="['add-button', showTableColumnList === 2 && 'active-button', getDisabledBtn('norm') && 'disabled-btn']"
                      @click.stop="openList('norm')"><i class="el-icon-plus"></i>添加指标
                    </div>
                    <div v-if="showTableColumnList === 2" class="graph-attr-list">
                      <el-input class="dimensionSearch" v-model="indicatorSearch"></el-input>
                      <div class="list-content">
                        <div
                          :class="['graph-attr-item', getSelectClass(column, 'norm') && 'select-item', getDisabledClass(column, 'norm') && 'disabled-item']"
                          v-for="column in getNumberNormColumns" :key="column.id"
                          @click.stop="selectItem('norm', column)"
                          :title="column.name">
                          <span>{{ column.name }}</span>
                          <i class="el-icon-check"></i>
                        </div>
                        <div v-if="getNumberNormColumns.length === 0" class="none">暂无数据</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="attr-item statistics-value">
                  <div class="title">统计值</div>
                  <template v-if="statisticsId !== '' && !isIdentity">
                    <el-row>
                      <el-col :span="16" class="elect-width">
                        <public-combobox v-model="statisticsId" :options="numberStatisticsColumns" :clearable="false"
                                         @change="statisticsChange"></public-combobox>
                      </el-col>
                      <el-col :span="8" class="elect-width-right">
                        <public-combobox v-model="diagramParams.statisticsType" :options="statisticsTypes"
                                         :clearable="false"></public-combobox>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else>
                    <public-combobox v-model="statisticsId" :options="numberStatisticsColumns" :clearable="false"
                                     @change="statisticsChange"></public-combobox>
                  </template>
                </div>
                <div class="attr-item attr-item-statistics-title">
                  <div class="title">数值标题</div>
                  <el-input v-model="diagramParams.statisticsTitle"></el-input>
                </div>
              </template>
              <div class="attr-item">
                <div class="title">定时更新</div>
                <public-combobox v-model="diagramParams.timing" :options="timeList"></public-combobox>
              </div>
              <div class="attr-item">
                <div class="expression">
                  <filter-senior-panel
                    v-if="!loading"
                    :reportService="reportService"
                    @updateSeniorFilter="updateSeniorFilter"
                    :isGraphReport="true" :selectTable="selectTable"
                    @beforeOpen="beforeOpen"
                    :isUseDatasource="isUseDatasource"
                  ></filter-senior-panel>
                </div>
              </div>
              <div class="stat-scope">统计范围</div>
              <div class="attr-item time">
                <div class="title">时间</div>
                <public-combobox v-model="diagramParams.statisticsTime" :options="getTimeColumns"
                                 :clearable="false"></public-combobox>
              </div>
              <div class="attr-item">
                <div class="title">范围</div>
                <public-combobox v-model="statisticsScope" :options="statisticsScopeList"
                                 :clearable="false"></public-combobox>
                <!-- 过去几天 -->
                <div class="public-select" v-if="statisticsScope === 'PAST'">
                  <public-combobox v-model="diagramParams.passDate" :options="passDateList"
                                   :clearable="false"></public-combobox>
                </div>
                <!-- 自定义时间 -->
                <div class="public-select" v-if="statisticsScope === 'CUSTOM'">
                  <el-date-picker
                    v-model="customTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :unlink-panels="true">
                  </el-date-picker>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="diagram-style-setting" v-if="data">
          <!-- 样式设计 -->
          <style-setting :data="data" :collapses="data.styleList" @recoverSetting="recoverSetting" :defaultOpen="false"></style-setting>
        </div>
      </div>
      <div class="attr-footer">
        <el-button type="primary" :icon="saveIng ? 'el-icon-loading' : ''" @click="save">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
    <div v-if="isRefresh" :class="getCharClass" :style="{'background-color': getBgc(data.backgroundAndBorder)}">
      <template v-if="isCustomPageRuntime">
        <div class="time-range" :style="getFontStyle(data.chartFont)">
          时间范围:{{getTimeRangeName}}
          <span class="change-time"><i class="el-icon-edit" @click="showCustomTime"></i></span>
        </div>
        <div v-if="customTimeFlag" class="amendTime">
          <public-combobox v-model="customData.statisticsScope" :options="statisticsScopeList"
                           :clearable="false"></public-combobox>
          <!-- 过去几天 -->
          <div class="public-select" v-if="customData.statisticsScope === 'PAST'">
            <public-combobox v-model="customData.passDate" :options="passDateList" :clearable="false"></public-combobox>
          </div>
          <!-- 自定义时间 -->
          <div class="public-select" v-if="customData.statisticsScope === 'CUSTOM'">
            <el-date-picker
              v-model="customData.customTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :unlink-panels="true">
            </el-date-picker>
          </div>
          <div class="bottom-button">
            <el-button type="primary" @click="confirm">确定</el-button>
            <el-button @click="close">取消</el-button>
          </div>
        </div>
      </template>
      <div v-if="showHint" class="hint">可设置多种类型统计图</div>
      <div v-if="noneData" class="hint none-data">没有记录</div>
      <div v-if="!showHint && !noneData" :class="['chart-container', !showOperation && 'chart-container-design']">
        <!-- hintPosition 控制提示是显示在右下角还是左上角 目前需求只需要改变饼状图-->
        <template v-if="diagramParams.reportType === '2'">
          <histogram-report ref="histogramReportDesign" v-if="graphData.length > 0 && graphSetting.norm.length > 0"
                            :graphData="graphData" :norm="graphSetting.norm[0].norm"
                            :dimensionality="graphSetting.dimensionality"
                            :isCustomPage="isCustomPage !== undefined ? isCustomPage : !showOperation"
                            :hintPosition="false"
                            :chartFont="data.chartFont"
                            :columnColor="data.columnColor"
                            :lineStyle="data.tableDivider"
                            :controlData="data"
                            :bgc="data.backgroundAndBorder"
                            :isMagnify="isMagnify"></histogram-report>
        </template>
        <template v-if="diagramParams.reportType === '3'">
          <pie-report ref="pieReportDesign"
                      v-if="graphData.length > 0 && graphSetting.norm.length > 0"
                      :graphData="graphData"
                      :norm="graphSetting.norm[0].norm"
                      :dimensionality="graphSetting.dimensionality"
                      :hintPosition="true"
                      :chartFont="data.chartFont"
                      :controlData="data"
                      :bgc="data.backgroundAndBorder"
                      :isMagnify="isMagnify"></pie-report>
        </template>
        <template v-if="diagramParams.reportType === '4'">
          <line-report ref="lieReportDesign"
                       v-if="graphData.length > 0 && graphSetting.norm.length > 0"
                       :graphData="graphData"
                       :norm="graphSetting.norm[0].norm"
                       :dimensionality="graphSetting.dimensionality"
                       :hintPosition="false"
                       :chartFont="data.chartFont"
                       :lineStyle="data.tableDivider"
                       :controlData="data"
                       :bgc="data.backgroundAndBorder"
                       :isMagnify="isMagnify"></line-report>
        </template>
        <template v-if="diagramParams.reportType === '6'">
          <div v-if="graphData.length > 0"
               :class="['statistics-chart', data.headTitle && data.headTitle.show && 'statistics-has-title']">
            <div class="statistics-content">
              <div class="statistics-chart-title" :title="data.diagramParams.statisticsTitle"
                   :style="getFontStyle(data.remakeFont)">
                {{data.diagramParams.statisticsTitle}}
              </div>
              <div class="statistics-chart-value" :style="getFontStyle(data.numberFont)">
                {{graphData[0].statisticsValue}}
              </div>
            </div>
          </div>
        </template>
        <template v-if="diagramParams.reportType === '8'">
          <funnel-report ref="funnelReportDesign"
                       v-if="graphData.length > 0 && graphSetting.norm.length > 0"
                       :graphData="graphData"
                       :norm="graphSetting.norm[0].norm"
                       :dimensionality="graphSetting.dimensionality"
                       :hintPosition="true"
                       :chartFont="data.chartFont"
                       :lineStyle="data.tableDivider"
                       :bgc="data.backgroundAndBorder"></funnel-report>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ReportService from '../../../../store/report/reportService'
import Report from '../../../../store/report/report'
import Column from '../../../../store/report/column'
import HistogramReport from '../../../public/graphReport/histogram-report'
import lineReport from '../../../public/graphReport/line-report'
import pieReport from '../../../public/graphReport/pie-report'
import publicCombobox from '@/components/public/public-combobox.vue'
import FilterSeniorPanel from './filter-senior-panel'
import Controls from './assets/js/controls'
import styleSetting from './style-setting/style-setting'
import setStyle from '../../../public/setStyle'
import funnelReport from '../../../public/graphReport/funnel-report'

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    showOperation: {
      type: Boolean,
      default: true
    },
    isCustomPage: undefined,
    isCustomPageRuntime: {
      type: Boolean,
      default: false
    },
    // 因为运行页也用的是同一个组件，但是 getStyleSetting 不需要，所以不设置 required
    getStyleSetting: {
      type: Function,
      default: function (args) {}
    },
    getStyleWithStyleList: {
      type: Function,
      default: function (args) {}
    },
    isMagnify: {
      default: false
    }
  },
  components: {publicCombobox, FilterSeniorPanel, HistogramReport, lineReport, pieReport, styleSetting, funnelReport},
  mixins: [setStyle],
  name: 'diagram',
  data () {
    return {
      diagramParams: {},
      tables: [],
      chartTypes: [
        {
          name: '柱状图',
          basicUrl: require('./assets/images/bar.png'),
          activeUrl: require('./assets/images/bar-active.png'),
          type: '2'
        },
        {
          name: '折线图',
          basicUrl: require('./assets/images/line.png'),
          activeUrl: require('./assets/images/line-active.png'),
          type: '4'
        },
        {
          name: '饼状图',
          basicUrl: require('./assets/images/pie.png'),
          activeUrl: require('./assets/images/pie-active.png'),
          type: '3'
        },
        {
          name: '数值图',
          basicUrl: require('./assets/images/statistics.png'),
          activeUrl: require('./assets/images/statistics-active.png'),
          type: '6'
        },
        {
          name: '漏斗图',
          basicUrl: require('./assets/images/funnel.png'),
          activeUrl: require('./assets/images/funnel-active.png'),
          type: '8'
        }
      ],
      hoverType: '',
      reportService: new ReportService(),
      report: new Report(),
      options: {
        dataSourceReports: [],
        leftPanel: {type: '', id: ''}
      },
      selectTable: {},
      // 统计值 id
      statisticsId: '',
      graphSetting: {
        dimensionality: [],
        norm: []
      },
      showTableColumnList: 0,
      editGraphObj: {},
      columns: [],
      statisticsScope: '',
      statisticsTypes: [
        {name: '求和', id: 'SUM'},
        {name: '统计', id: 'COUNT'},
        {name: '最小值', id: 'MIN'},
        {name: '最大值', id: 'MAX'},
        {name: '平均值', id: 'AVG'}
      ],
      timeList: [
        {name: '5秒', id: '5000'},
        {name: '10秒', id: '10000'},
        {name: '30秒', id: '30000'},
        {name: '1分钟', id: '60000'},
        {name: '10分钟', id: '600000'}
      ],
      statisticsScopeList: [
        {name: '今天', id: 'CURRENTDAY'},
        {name: '昨天', id: 'LASTDAY'},
        {name: '本周', id: 'THISWEEK'},
        {name: '上周', id: 'LASTWEEK'},
        {name: '本月', id: 'THISMONTH'},
        {name: '上月', id: 'LASTMONTH'},
        {name: '本季度', id: 'THISQUARTER'},
        {name: '上季度', id: 'LASTQUARTER'},
        {name: '本年', id: 'THISYEAR'},
        {name: '上年', id: 'LASTYEAR'},
        {name: '全部', id: 'ALL'},
        {name: '过去...天', id: 'PAST'},
        {name: '自定义时间', id: 'CUSTOM'}
      ],
      // 过去几天
      passDateList: [
        {name: '7天', id: '7'},
        {name: '14天', id: '14'},
        {name: '30天', id: '30'},
        {name: '90天', id: '90'},
        {name: '180天', id: '180'},
        {name: '365天', id: '365'}
      ],
      showHint: true,
      graphData: [],
      controls: new Controls({type: 'diagram'}),
      customTime: [],
      loading: true,
      timer: null,
      canUpdate: false,
      isRefresh: true,
      numberNormColumns: [],
      numberStatisticsColumns: [],
      mainTableId: '',
      noneData: false,
      customTimeFlag: false,
      customData: {
        statisticsScope: '',
        passDate: '',
        customTime: []
      },
      //  维度搜索值
      dimensionSearch: '',
      //  指标搜索值
      indicatorSearch: '',
      activeNames: ['1'],
      saveIng: false,
      isUseDatasource: false,
      datasourceId: ''
    }
  },
  async created () {
    await this.initCreated()
  },
  methods: {
    showCustomTime () {
      if (this.customTimeFlag === false) {
        this.customTimeFlag = true
        this.customData.statisticsScope = this.statisticsScope
        this.customData.passDate = this.customData.passDate || this.diagramParams.passDate
        this.customData.customTime = this.customTime
      }
    },
    statisticsChange (val) {
      let item = this.numberStatisticsColumns.find(c => c.id === val)
      this.diagramParams.statisticsTitle = item.name
      this.beforeOpen()
    },
    // 保存的时候需要刷新图表
    async initCreated (isRefresh = false) {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (isRefresh) {
        this.isRefresh = false
        this.$nextTick(async () => {
          this.isRefresh = true
          this.reportService.report = new Report()
          this.reportService.options = this.options
          await this.loadTables()
          await this.getAllTables()
          await this.initData()
        })
      } else {
        this.reportService.report = new Report()
        this.reportService.options = this.options
        await this.loadTables()
        await this.getAllTables()
        await this.initData()
      }
    },
    async initData () {
      let data = this.clearJoin(this.data.diagramParams)
      if (data.mainTableId !== '') {
        this.mainTableId = data.mainTableId
        let statisticsScope = data.statisticsScope
        if (data.reportType === '6' && data.statisticsModel.columnId) {
          this.statisticsId = data.statisticsModel.columnId
        }
        if (data.reportType !== '6') {
          this.graphSetting.dimensionality = data.dimensionality
          if (Object.keys(data.norm).length > 0) {
            this.graphSetting.norm = [data.norm]
          }
        }
        // 如果选的是过去几天
        if (data.statisticsScope.includes('PAST')) {
          statisticsScope = 'PAST'
        }
        if (data.statisticsScope === 'CUSTOM') {
          statisticsScope = 'CUSTOM'
          this.customTime = data.customTime.split(',')
        }
        this.statisticsScope = statisticsScope
        this.reportService.report = Object.assign(this.reportService.report, data)
        let table = this.tables.find(t => t.id === data.mainTableId)
        if (table) {
          let type
          if (!table.tableId) {
            type = 'fz'
            this.isUseDatasource = true
          }
          await this.getColumns(table.tableId || table.id, type).then(res => {
            this.columns = res.columns
            this.selectTable = res
            this.numberNormColumns = this.$_.merge([], this.getNorm(res.columns, '数据总量', type))
            this.numberStatisticsColumns = this.$_.merge([], this.getNorm(res.columns, '记录数量', type))
          })
        }
        // 绘制图
        this.canUpdate = true
        if (this.datasourceId && this.isUseDatasource === true) {
          data.datasourceId = this.datasourceId
          data.isUseDatasource = true
        }
        this.printChart(data, true)
      } else {
        this.loading = false
      }
      if (data.statisticsTitle === undefined) {
        data.statisticsTitle = data.statisticsModel && data.statisticsModel.name ? data.statisticsModel.name : ''
      }
      this.diagramParams = data
      this.setStyleSetting(data.reportType, false)
    },
    printChart (data, isInit = false) {
      this.$axios.post('/report-api/report/data/graphicReportData', data).then(res => {
        if (!isInit) {
          this.data.diagramParams = data
        }
        this.graphData = res.data || []
        this.showHint = false
        // 如果设置了定时更新
        if (data.timing !== '' && this.canUpdate) {
          this.canUpdate = false
          this.timingUpdate(parseFloat(data.timing))
        }
        this.$nextTick(() => {
          this.saveIng = false
          if (!isInit) {
            this.$emit('addControls', this.data, false)
          }
          if (res.data.length === 0) {
            this.noneData = true
            // 没有记录的情况就不渲染图表了。。。所以得关闭loading
            if (this.loading) {
              this.loading = false
            }
          } else {
            this.noneData = false
            this.$nextTick(async () => {
              if (this.diagramParams.reportType === '2') {
                await this.$refs.histogramReportDesign && this.$refs.histogramReportDesign.drawLine()
              } else if (this.diagramParams.reportType === '3') {
                await this.$refs.pieReportDesign && this.$refs.pieReportDesign.drawLine()
              } else if (this.diagramParams.reportType === '4') {
                await this.$refs.lieReportDesign && this.$refs.lieReportDesign.drawLine()
              } else if (this.diagramParams.reportType === '8') {
                await this.$refs.funnelReportDesign && this.$refs.funnelReportDesign.drawLine()
              }
              if (this.loading) {
                this.loading = false
              }
            })
          }
        })
      }).catch(res => {
        if (this.saveIng) {
          this.saveIng = false
        }
      })
    },
    save () {
      if (this.saveIng) return false
      if (this.diagramParams.mainTableId === '') {
        return this.$message.error('请选择归档表')
      }
      this.saveIng = true
      let data = this.clearJoin(this.diagramParams)
      let report
      if (this.isUseDatasource === true) {
        report = this.clearJoin(this.reportService.build(this.isUseDatasource, this.selectTable))
      } else {
        report = this.clearJoin(this.reportService.build())
      }
      data = Object.assign(this.clearJoin(report), data)
      // 这三个值有毒 不能被覆盖 data中这三个值没有更改过
      data.systemFilterSwitch = report.systemFilterSwitch
      data.filterExpression = report.filterExpression
      data.filterTempExpression = report.filterTempExpression
      data.filters = report.filters
      data.columns = report.columns

      data.columns = report.columns
      // 统计图
      if (this.diagramParams.reportType === '6') {
        if (!this.statisticsId) {
          this.saveIng = false
          return this.$message.info('请选择统计值')
        }
        let column = this.clearJoin(report.columns.find(c => c.columnId === this.statisticsId))
        if (column) {
          delete column.format
          data.statisticsModel = {...column}
          data.dimensionality = []
          data.norm = {}
        }
      } else {
        data.dimensionality = this.graphSetting.dimensionality
        data.dimensionality.length > 0 && data.dimensionality.forEach(d => {
          let column = this.reportService.report.columns.find(c => c.columnId === d.id)
          d.columnId = d.id
          d.reportColumnId = column.id
          d.tableId = data.mainTableId
          d.unit = d.dimensionality.unit
        })
        data.norm = this.graphSetting.norm.length !== 0 ? this.graphSetting.norm[0] : {}
        if (Object.keys(data.norm).length > 0) {
          let column = this.reportService.report.columns.find(c => c.columnId === data.norm.id)
          data.norm.columnId = data.norm.id
          data.norm.reportColumnId = column.id
          data.norm.tableId = data.mainTableId
        }
        data.statisticsModel = {}
      }
      data.statisticsScope = this.statisticsScope
      // 过去几天
      if (this.statisticsScope === 'PAST') {
        data.statisticsScope = `PAST${this.diagramParams.passDate}`
      } else if (this.statisticsScope === 'CUSTOM') {
        data.customTime = this.customTime ? this.customTime.join(',') : ''
      }
      if (this.statisticsScope !== 'CUSTOM') {
        data.customTime = ''
        this.customTime = []
      }
      if (this.statisticsScope !== 'PAST') {
        data.passDate = ''
      }
      data.mainTableId = this.reportService.report.mainTableId
      data.statisticsMap = this.columns.find(c => c.id === data.statisticsTime) || {}
      this.$set(this, 'diagramParams', data)
      this.canUpdate = true
      this.timer && clearInterval(this.timer)
      if (this.datasourceId && this.isUseDatasource === true) {
        data.datasourceId = this.datasourceId
        data.isUseDatasource = true
      }
      this.printChart(data)
    },
    cancel () {
      this.$emit('closeDialog')
    },
    async addColumn (column) {
      if (column) {
        let pingyin = await this.reportService.getPinyinByHanzi(column.name)
        this.$_.merge(column, {...pingyin})
        let reportColumn = Column.create(column)
        reportColumn.columnType = column.dataType || column.columnType
        this.reportService.createOrUpdate(reportColumn)
      }
    },
    saveGraphAttr (type) {
      let data = this.graphSetting[type].find(g => g.id === this.editGraphObj.id)
      data[type] = {...this.editGraphObj[type]}
      this.closeDialogWithGraph()
    },
    closeDialogWithGraph () {
      this.$set(this, 'editGraphObj', {})
    },
    editData (item, type) {
      if (type !== 'norm') {
        let columnType = item.dataType || item.columnType
        if (columnType.toUpperCase() !== 'DATE' && columnType.toUpperCase() !== 'DATETIME') {
          return false
        }
      }
      let obj = this.clearJoin(item)
      obj.type = type
      this.editGraphObj = obj
    },
    deleteData (item, type) {
      let i = this.graphSetting[type].findIndex(g => g.id === item.id)
      if (i !== -1) {
        this.graphSetting[type].splice(i, 1)
      }
      this.$nextTick(this.beforeOpen())
    },
    openList (type) {
      if (type === 'dimensionality') {
        if (this.diagramParams.reportType === '2' || this.diagramParams.reportType === '4') {
          if (this.graphSetting[type].length === 2) {
            return false
          }
        } else if (this.diagramParams.reportType === '3') {
          if (this.graphSetting[type].length === 1) {
            return false
          }
        }
      } else {
        if (this.graphSetting[type].length === 1) {
          return false
        }
      }
      this.showTableColumnList = type === 'dimensionality' ? 1 : 2
      this.$nextTick(() => {
        document.querySelector('.graph-attr-list') && document.querySelector('.graph-attr-list').addEventListener('mouseleave', () => {
          if (this.showTableColumnList > 0) {
            this.dimensionSearch = ''
            this.indicatorSearch = ''
            this.showTableColumnList = 0
          }
        })
      })
    },
    clearJoin (object) {
      return typeof object === 'object' ? JSON.parse(JSON.stringify(object)) : object
    },
    getAllTables () {
      return this.$axios.get('/report-api/report/definition/dataSourceReports').then(res => {
        this.reportService.options.dataSourceReports = res.data
        this.tables = this.tables.concat(res.data)
      })
    },
    selectChartType (item) {
      if (this.diagramParams.reportType === item.type) return false
      this.setStyleSetting(item.type)
      if (item.type === '3' && this.graphSetting.dimensionality.length > 1) {
        this.graphSetting.dimensionality.pop()
      }
      if (item.type === '6') {
        this.$set(this.graphSetting, 'dimensionality', [])
        this.$set(this.graphSetting, 'norm', [])
      } else {
        this.statisticsId = ''
      }
      this.diagramParams.reportType = item.type
      this.reportService.report.filterExpression = ''
      this.reportService.report.filterTempExpression = ''
      this.reportService.report.filters = []
      this.reportService.report.columns = []
      this.$nextTick(this.beforeOpen())
    },
    setStyleSetting (type, updateDefault = true) {
      // 切换图表类型的时候需要清空样式设计
      // 这个type为什么这么乱？。。
      // 根据图标类型不同，展示的styleList也不一致。
      // 柱状图：['1', '3', '10', '11']  type：'2'
      // 折线图：['1', '3', '10', '11']  type：'4'
      // 饼状图：['1', '3', '10']  type：'3'
      // 统计图：['1', '8', '9']   type：'6'
      let styleList = []
      switch (type) {
        case '2':
          styleList = ['1', '3', '10', '11', '12']
          break
        case '4':
          styleList = ['1', '3', '10', '11']
          break
        case '3':
          styleList = ['1', '3', '10']
          break
        case '6':
          styleList = ['1', '8', '9']
          break
        case '7':
          styleList = ['1', '3', '10']
          break
      }
      this.data.styleList = styleList
      if (updateDefault) {
        // 根据 styleList 切换 style的值
        let defaultStyle = this.getStyleWithStyleList(['1', '3', '8', '9', '10', '11'])
        defaultStyle && this.$_.mergeWith(this.data, defaultStyle, (oldVal, newVal) => this.$_.cloneDeep(newVal) || oldVal)
      }
    },
    updateSeniorFilter (seniorFilter) {
      if (seniorFilter && seniorFilter.filters) {
        this.reportService.report.filters = seniorFilter.filters
      } else {
        this.reportService.report.filters = []
      }
      this.$set(this.reportService.report, 'systemFilterSwitch', seniorFilter.systemFilterSwitch)
      this.$set(this.reportService.report, 'filterExpression', seniorFilter.expression)
    },
    beforeOpen () {
      // 生成列
      let columns = []
      // 如果不是统计图的话
      if (this.diagramParams.reportType !== '6') {
        columns = this.clearJoin([...this.graphSetting.dimensionality, ...this.graphSetting.norm])
      } else {
        columns = this.columns.find(c => c.id === this.statisticsId) ? [this.columns.find(c => c.id === this.statisticsId)] : []
        if (columns.length > 0) {
          let type = columns[0].dataType || columns[0].columnType
          if (type.toUpperCase() === 'IDENTITY' && columns[0].primaryKey) {
            columns[0].name = '记录数量'
            columns[0].summaryType = 'COUNT'
          }
        }
      }
      let rColumns = this.clearJoin(this.reportService.report.columns)
      this.reportService.report.columns = []
      if (columns.length > 0) {
        columns.forEach(async c => {
          await this.addColumn(c)
        })
        let unWatch = this.$watch(() => this.reportService.report.columns.length, length => {
          if (length === columns.length) {
            unWatch()
            // 替换id
            let rc = this.$_.merge([], this.reportService.report.columns)
            rc.forEach(c => {
              let col = rColumns.find(r => r.columnId === c.columnId)
              if (col) {
                c.id = col.id
              }
            })
            this.reportService.report.columns = rc
            let filters = this.reportService.report.filters
            filters.filter(f => {
              // 剔除不存在的列的筛选条件
              if (!rc.find(r => r.id === f.columnId)) {
                return false
              }
            })
            this.reportService.report.filters = filters
          }
        }, {deep: true})
      }
    },
    async selectMainTableId (value) {
      this.$refs.selectMainTable.$refs && this.$refs.selectMainTable.$refs.select && this.$refs.selectMainTable.$refs.select.blur()
      await this.clearFields()
      this.$nextTick(async () => {
        this.reportService.report.mainTableId = value
        this.mainTableId = value
        let table = this.tables.find(t => t.id === value)
        if (table) {
          let type
          if (!table.tableId) type = 'fz'
          await this.getColumns(table.tableId || table.id, type).then(res => {
            this.columns = res.columns
            this.selectTable = res
            if (type) {
              this.isUseDatasource = true
              this.datasourceId = res.id
              this.numberNormColumns = this.$_.merge([], this.getNorm(res.columns, '数据总量', type))
              this.numberStatisticsColumns = this.$_.merge([], this.getNorm(res.columns, '记录数量', type))
            } else {
              this.numberNormColumns = this.$_.merge([], this.getNorm(res.columns, '数据总量', type))
              this.numberStatisticsColumns = this.$_.merge([], this.getNorm(res.columns, '记录数量', type))
            }
          })
        }
      })
    },
    async clearFields () {
      let data = this.controls.diagramParams
      this.reportService.report = new Report()
      await this.loadTables()
      await this.getAllTables()
      // 选择归档表的时候需要把这些东西清空
      let keys = ['dimensionality', 'norm', 'statisticsModel', 'statisticsType', 'statisticsTime', 'filterExpression']
      for (let key in this.data.diagramParams) {
        if (keys.includes(key)) {
          this.$set(this.diagramParams, key, data[key])
        }
      }
      this.reportService.report.filterExpression = ''
      this.reportService.report.filterTempExpression = ''
      this.reportService.report.filters = []
      this.statisticsId = ''
      this.$set(this, 'graphSetting', {
        dimensionality: [],
        norm: []
      })
      this.dimensionSearch = ''
      this.indicatorSearch = ''
      this.showTableColumnList = 0
      if (!this.showHint) {
        this.showHint = true
      }
    },
    loadTables () {
      return this.$axios.get('/report-api/report/definition/tables').then(res => {
        this.reportService.options.tables = res.tables
        this.tables = res.data || []
      })
    },
    getColumns (tableId, type) {
      if (type) {
        return new Promise(resolve => {
          return this.$axios.get(`/report-api/report/definition/${tableId}?type=run`).then(res => resolve(res.data))
        })
      } else {
        return new Promise(resolve => {
          return this.$axios.get(`/data-api/table/${tableId}`).then(res => resolve(res.data))
        })
      }
    },
    selectItem (type, column) {
      let i = this.graphSetting[type].findIndex(g => g.id === column.id)
      if (i === -1) {
        if (type !== 'norm') {
          if (this.diagramParams.reportType === '2' || this.diagramParams.reportType === '4') {
            if (this.graphSetting[type].length === 2) {
              return false
            }
          } else if (this.diagramParams.reportType === '3') {
            if (this.graphSetting[type].length === 1) {
              return false
            }
          }
        } else {
          if (this.graphSetting[type].length === 1) {
            return false
          }
        }
        let data = this.clearJoin(column)
        let columnType = data.dataType || data.columnType
        data.dimensionality = {unit: columnType.toUpperCase() === 'DATE' || columnType.toUpperCase() === 'DATETIME' ? 'MONTH' : ''}
        data.norm = {
          showType: '默认',
          showUnit: '',
          decimalDigits: ''
        }
        data.graphType = type
        this.graphSetting[type].push(data)
      } else {
        this.graphSetting[type].splice(i, 1)
      }
      this.showTableColumnList = 0
      this.$nextTick(this.beforeOpen())
    },
    timingUpdate (timer) {
      this.timer = setInterval(() => {
        this.printChart(this.data.diagramParams, true)
      }, timer)
    },
    getNorm (cls, name, fztype) {
      let columns = []
      if (this.columns.length > 0) {
        let columnType = ['int', 'bigint', 'decimal', 'decimal0', 'decimal1', 'decimal2', 'decimal3', 'decimal4', 'decimal5']
        let allColumns = this.$_.merge([], cls) || []
        columns = allColumns.length ? allColumns.filter(a => {
          if (a.columnType) {
            return columnType.includes(a.columnType.toLowerCase())
          } else if (a.dataType) {
            return columnType.includes(a.dataType.toLowerCase())
          }
        }) : []
        let idColumns = allColumns.filter(c => {
          let type = c.dataType || c.columnType
          return type.toUpperCase() === 'IDENTITY' && c.primaryKey
        })
        if (fztype) {
          idColumns.push({
            basis: null,
            columnType: 'IDENTITY',
            exportable: true,
            // eslint-disable-next-line no-template-curly-in-string
            expressionText: '${17CC0457-2670-0092-08A2-8451712932EC+undefined,标识,varchar}',
            format: {
              id: '17CDA006-6BE0-00C6-0884-DE5C052A92A8',
              dataFormat: '{"dataType":"","dataformat":"DA","decimalDigits":0,"roundWay":"","width":"","align":"center"}',
              colorFormats: '[{"id":"17CDA006-6BE0-00C7-08D3-7045D66B82FE","col…"","color":"","condition":"","warningText":true}]',
              displayFormats: '[{"id":"17CDA006-6BE0-00C8-B727-464DA9C8870B","type":"","condition":"","value":""}]'},
            hidden: false,
            hiddenExpressionText: '',
            // id: '17CDA006-6BE0-00C5-7E60-E0816E25589F',
            id: 'sjzl',
            lineWrap: false,
            name: '数据总量',
            pinyinFirstChar: 'bs',
            pinyinName: 'biaoshi',
            progressDisplay: false,
            showPicture: null,
            sort: 2,
            summary: null,
            summaryType: 'COUNT',
            timeFormat: null,
            useThousandth: false
          })
        }
        let count = idColumns && idColumns.length > 0 ? {...idColumns[0]} : null
        if (count) {
          count.name = name
          count.summaryType = 'COUNT'
        }
        columns.unshift({...count})
        // 留着。鬼知道后面会不会需要过滤
        // // 需要过滤指标已经选过的字段
        // columns = columns.filter(c => {
        //   if (this.graphSetting.dimensionality.length > 0) {
        //     return !this.graphSetting.dimensionality.find(f => f.id === c.id)
        //   }
        // })
      }
      return columns
    },
    resizeChartSize () {
      if (this.diagramParams.reportType === '2') {
        this.$refs.histogramReportDesign && this.$refs.histogramReportDesign.resize()
      } else if (this.diagramParams.reportType === '3') {
        this.$refs.pieReportDesign && this.$refs.pieReportDesign.resize()
      } else if (this.diagramParams.reportType === '4') {
        this.$refs.lieReportDesign && this.$refs.lieReportDesign.resize()
      } else if (this.diagramParams.reportType === '8') {
        this.$refs.funnelReportDesign && this.$refs.funnelReportDesign.resize()
      }
    },
    close () {
      this.customTimeFlag = false
      this.customData = {
        statisticsScope: '',
        passDate: '',
        customTime: []
      }
    },
    async confirm () {
      this.customTimeFlag = false
      this.statisticsScope = this.customData.statisticsScope
      this.passDate = this.customData.passDate
      this.customTime = this.customData.customTime
      this.data.diagramParams.statisticsScope = this.customData.statisticsScope + this.customData.passDate
      this.data.diagramParams.passDate = this.customData.passDate || ''
      this.data.diagramParams.customTime = this.customData.customTime.join(',')
      this.printChart(this.data.diagramParams)
    },
    // 恢复默认设置
    recoverSetting () {
      let defaultStyle = this.getStyleSetting(this.data.type)
      defaultStyle && this.$_.assign(this.data, defaultStyle)
    }
  },
  computed: {
    getTimeColumns () {
      let columns = []
      columns = this.columns.filter(c => {
        let columnType = c.dataType || c.columnType
        return columnType.toUpperCase() === 'DATE' || columnType.toUpperCase() === 'DATETIME'
      })
      return columns
    },
    getDimensionalityColumn () {
      if (this.dimensionSearch) {
        let value = this.dimensionSearch
        return this.columns.filter(c => c.name.includes(value) || c.pinyinFirstChar.includes(value) || c.pinyinName.includes(value))
      } else {
        return this.columns
      }
    },
    getNumberNormColumns () {
      if (this.indicatorSearch) {
        let value = this.indicatorSearch
        return this.numberNormColumns.filter(c => c.name.includes(value) || c.pinyinFirstChar.includes(value) || c.pinyinName.includes(value))
      } else {
        return this.numberNormColumns
      }
    },
    getColumnType (data) {
      return data => {
        let type = data.dataType || data.columnType
        return type.toUpperCase() !== 'DATE' && type.toUpperCase() !== 'DATETIME'
      }
    },
    getSrc () {
      return item => {
        if (this.diagramParams.reportType) {
          if (this.hoverType) {
            if (item.type === this.diagramParams.reportType) {
              return item.activeUrl
            } else {
              return item.type === this.hoverType ? item.activeUrl : item.basicUrl
            }
          } else {
            return item.type === this.diagramParams.reportType ? item.activeUrl : item.basicUrl
          }
        }
        if (this.hoverType) {
          return item.type === this.hoverType ? item.activeUrl : item.basicUrl
        }
        return item.basicUrl
      }
    },
    getSelectClass () {
      return (column, type) => {
        return this.graphSetting[type].find(g => g.id === column.id)
      }
    },
    getDisabledClass () {
      return (column, type) => {
        // 可以选择两个维度
        let result = false
        if (type !== 'norm') {
          if (this.diagramParams.reportType === '2' || this.diagramParams.reportType === '4') {
            if (this.graphSetting[type].length === 2) {
              result = !this.graphSetting[type].find(g => g.id === column.id)
            }
          } else if (this.diagramParams.reportType === '3') {
            if (this.graphSetting[type].length === 1) {
              result = !this.graphSetting[type].find(g => g.id === column.id)
            }
          }
        } else {
          if (this.graphSetting[type].length === 1) {
            result = !this.graphSetting[type].find(g => g.id === column.id)
          }
        }
        return result
      }
    },
    getDisabledBtn () {
      return type => {
        let result = false
        if (type === 'dimensionality') {
          if (this.diagramParams.reportType === '2' || this.diagramParams.reportType === '4') {
            if (this.graphSetting[type].length === 2) {
              result = true
            }
          } else if (this.diagramParams.reportType === '3' || this.diagramParams.reportType === '8') {
            if (this.graphSetting[type].length === 1) {
              result = true
            }
          }
        } else {
          result = this.graphSetting[type].length === 1
        }
        return result
      }
    },
    isIdentity () {
      let result = false
      if (this.statisticsId !== '' && this.columns.length > 0) {
        let column = this.columns.find(c => c.id === this.statisticsId)
        if (column) {
          let type = column.dataType || column.columnType
          result = type.toUpperCase() === 'IDENTITY' && column.primaryKey
        }
      }
      return result
    },
    getTimeRangeName () {
      if (this.statisticsScope) {
        return this.statisticsScopeList.filter(n => n.id === this.statisticsScope)[0].name
      } else {
        return ''
      }
    },
    getClass () {
      return name => this.activeNames.indexOf(name) > -1 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
    },
    getCharClass () {
      return ['diagram-chart', !this.showOperation && 'diagram-chart-design', this.diagramParams.reportType === '6' && 'statistics', !this.showOperation && 'no-operation', this.diagramParams.reportType === '6' && !this.showOperation && 'statistics-chart-container', this.noneData && !this.showOperation && 'none-data-chart', this.showOperation && 'set-bottom']
    }
  },
  mounted () {
    if (this.showOperation) {
      document.getElementsByClassName('custom-page-design-dialog')[0].addEventListener('click', (e) => {
        if (this.showTableColumnList > 0 && !e.target.parentElement.classList.contains('dimensionSearch')) {
          this.dimensionSearch = ''
          this.indicatorSearch = ''
          this.showTableColumnList = 0
        }
      })
    }
  },
  beforeDestroy () {
    this.timer && clearInterval(this.timer)
  },
  watch: {
    'diagramParams.mainTableId': function (newValue, oldValue) {
      if (this.mainTableId !== newValue) {
        if (this.mainTableId && newValue && oldValue) {
          this.$confirm('', '切换归档表后，您当前的设置内容将被重置，是否继续？', {
            confirmButtonText: '取消',
            cancelButtonText: '继续',
            customClass: 'deleMessageBox-customPage',
            center: true
          }).then(async () => {
            this.diagramParams.mainTableId = this.mainTableId
            this.$refs.selectMainTable.$refs && this.$refs.selectMainTable.$refs.select && this.$refs.selectMainTable.$refs.select.blur()
          }).catch(() => {
            this.selectMainTableId(newValue)
          })
        } else {
          if (newValue) {
            this.selectMainTableId(newValue)
          }
        }
      }
    },
    '$route.path' (val) {
      this.resizeChartSize()
    }
  }
}
</script>

<style lang="scss">
  .diagram-container {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    background-color: transparent;

    .diagram-attr {
      width: 230px;
      border-right: 1px solid #DCDCDC;
      height: 100%;
      box-sizing: border-box;

      .attr-content {
        height: calc(100% - 50px);
        width: 100%;
        padding-right: 5px;
        padding-left: 9px;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;

        & > .default-attr {
          padding-bottom: 15px;

          & > .attr-item {
            padding-bottom: 17px;
            width: 205px;

            .title {
              color: #1A1A1A;
            }
          }

          & > .el-collapse {
            border: none;

            .el-collapse-item {
              .el-collapse-item__header {
                color: #1A1A1A;
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                position: relative;
                border: none;

                &:hover, &:active, &:focus {
                  color: #1A1A1A;
                }

                .el-collapse-item__arrow {
                  display: none;
                }

                .el-icon-arrow-down, .el-icon-arrow-up {
                  position: absolute;
                  right: 0;
                }

                .open-collapse {
                  position: absolute;
                  right: 20px;
                  font-size: 12px;
                  color: #999999;
                }
              }

              .el-collapse-item__wrap {
                border: none;
              }

              .el-collapse-item__content {
                padding: 0;

                .el-form-item {
                  margin-bottom: 0;

                  .el-form-item__label {
                    font-size: 12px;
                    color: #1A1A1A;
                  }

                  .form-item-right {
                    text-align: right;
                  }
                }

                .attr-item:first-child {
                  .title {
                    padding-top: 5px;
                  }
                }
              }
            }

            .line-cut-line {
              .el-collapse-item__wrap {
                .el-collapse-item__content {
                  padding: 6px 0;
                }
              }
            }
          }
        }

        .attr-item {
          position: relative;
          width: 205px;

          .title {
            padding: 11px 0 6px 0;
          }

          .el-select {
            width: 205px;
          }

          .chart-type {
            width: 205px;
            height: 28px;
            line-height: 28px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(194, 195, 196, 1);
            border-radius: 4px;
            padding-left: 6px;

            .chart-type-item {
              display: inline-block;
              width: 38px;
              cursor: pointer;
              height: 26px;
              vertical-align: center;
              text-align: center;

              .img {
                width: 14px;
                height: 14px;
              }
            }
          }

          .add-button {
            width: 205px;
            height: 28px;
            line-height: 26px;
            text-align: center;
            border: 1px dashed #C2C3C4;
            border-radius: 4px;
            cursor: pointer;
            position: relative;
          }

          .active-button {
            background-color: #ebf6ff;
            color: #54ABF1;
            border-color: #54ABF1;
          }

          .disabled-btn {
            background-color: #f4f4f5;
            color: #999;
            border-color: #999;
          }

          .expression {
            margin: 11px 0 11px 0;

            .filter-senior {
              .panel-title {
                .el-form {
                  .type-filter {
                    .el-col {
                      label {
                        font-size: 14px;
                      }
                    }
                  }
                }
              }
            }
          }

          .graph-attr-container {
            position: relative;
            width: 100%;
          }

          .graph-attr-list {
            position: absolute;
            top: 32px;
            z-index: 999;
            width: 205px;
            height: 170px;
            background: #fff;
            border: 1px solid rgba(238, 241, 243, 1);
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.09);
            border-radius: 4px;
            text-align: left;
            padding: 3px 0;

            .dimensionSearch {
              height: 30px;
              line-height: 30px;
            }

            .list-content {
              overflow: auto;
              height: 140px;
            }

            .graph-attr-item {
              width: 100%;
              position: relative;
              color: #333;
              padding: 0 12px;
              height: 28px;
              line-height: 28px;
              cursor: pointer;

              .el-icon-check {
                position: absolute;
                right: 18px;
                top: 6px;
                display: none;
              }

              &:hover {
                color: #54ABF1;
                background-color: #ECF5FF;

                .el-icon-check {
                  display: inline-block;
                }
              }

              & > span {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: inline-block;
                width: 100%;
              }
            }

            .select-item {
              color: #54ABF1;

              .el-icon-check {
                display: inline-block;
                color: #54ABF1;
              }
            }

            .disabled-item {
              color: #999;

              &:hover {
                color: #999;

                .el-icon-check {
                  display: none;
                }
              }
            }

            .none {
              text-align: center;
              padding-top: 70px;
            }
          }

          .selected-graph-list {
            width: 205px;

            .selected-item {
              width: 100%;
              height: 28px;
              padding: 0 11px;
              line-height: 26px;
              border: 1px solid #C2C3C4;
              border-radius: 4px;
              margin-bottom: 10px;
              cursor: pointer;
              position: relative;

              .operation-graph-container {
                position: absolute;
                right: 12px;
                display: none;

                span {
                  color: #D5D6D9;
                }

                .el-icon-edit {
                  &:hover {
                    color: #8ECAF9;
                  }

                  &:active {
                    color: #388DD2;
                  }
                }

                .el-icon-error {
                  &:hover {
                    color: #FB9391;
                  }

                  &:active {
                    color: #EE5451;
                  }
                }

                .disabled-icon-edit {
                  color: #D5D6D9;

                  &:hover, &:active, &:focus {
                    color: #D5D6D9;
                  }
                }
              }

              &:hover {
                > .operation-graph-container {
                  display: inline-block;
                }
              }

              .edit-dialog-warp {
                position: absolute;
                z-index: 999;
                top: 30px;
                right: 0;
                width: 178px;
                height: 118px;
                background: #fff;
                border: 1px solid rgba(238, 241, 243, 1);
                box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.09);
                border-radius: 4px;
                padding: 0 9px;

                .edit-dialog-title {
                  font-size: 12px;
                  color: #333;

                  .el-icon-info {
                    color: #C2C3C4;
                    font-size: 12px;

                    &:hover {
                      color: #54ABF1;
                    }
                  }
                }

                .edit-dialog-footer {
                  padding-top: 22px;
                  text-align: center;
                }

                .el-select {
                  width: 158px;
                }
              }

              .graph-index-dialog {
                height: 237px;
              }
            }
          }
        }

        .attr-item-statistics-title {
          .el-input {
            width: 205px;
          }
        }

        .statistics-value {
          width: 205px;
        }

        .stat-scope {
          color: #999;
          font-size: 12px;
        }

        .time {
          padding-top: 0;

          .title {
            padding-top: 5px;
          }
        }

        .elect-width {
          width: 129px;

          .el-select {
            width: 125px;
          }
        }

        .elect-width-right {
          width: 76px;

          .el-select {
            width: 76px;
          }
        }

        .public-select {
          margin-top: 11px;
          width: 205px;

          .el-date-editor {
            width: 205px;

            .el-range-separator {
              width: 25px;
            }
          }
        }
      }

      .attr-footer {
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-top: 10px;

        .el-button {
          width: 78px;
          height: 26px;
          background: rgba(70, 160, 252, 1);
          border-radius: 3px;
          padding: 0;
        }

        .el-button--default {
          background-color: #fff;
        }
      }
    }

    .diagram-chart {
      min-width: 880px;
      min-height: 536px;
      background-color: transparent;

      & > .hint {
        text-align: center;
        padding-top: 250px;
        color: #999;
      }

      & > .chart-container {
        min-width: 870px;
        height: 100%;
        overflow: auto;

        & > .statistics-chart {
          text-align: center;
          padding-top: 200px;
          position: relative;
          display: flex;
          align-items: center;

          .statistics-content {
            margin: 0 auto;

            .statistics-chart-title {
              font-size: 16px;
              color: #666;
              padding-bottom: 17px;
              text-align: center;
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .statistics-chart-value {
              font-size: 48px;
              width: 100%;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(26, 26, 26, 1);
              line-height: 39px;
              height: 39px;
              text-align: center;
            }
          }
        }
      }

      & > .chart-container-design {
        min-width: auto;
        overflow: hidden;
      }

      div {
        background-color: transparent;
      }
    }

    .set-bottom {
      & > .chart-container {
        .histogram-report-container {
          .custom-page-hint {
            bottom: 15px;
          }
        }
      }
    }

    .diagram-chart-design {
      min-width: auto;
      min-height: auto;
      overflow: hidden;
    }

    .none-data-chart {
      min-width: auto;
      min-height: auto;
      position: relative;

      & > .none-data {
        padding: 0;
        position: absolute;
        top: calc(50% - 16px);
        text-align: center;
        width: 100%;
      }

      & > .chart-container {
        min-width: auto;
        min-height: auto;
      }
    }

    .statistics {
      width: 100%;
      height: 100%;

      .chart-container {
        width: 100%;
        height: 100%;
      }
    }

    .no-operation {
      width: 100%;
      height: 100%;

      .chart-container {
        width: 100%;
        height: 100%;

        & > .statistics-chart {
          padding-top: 12%;
        }
      }
    }

    .statistics-chart-container {
      height: 100%;
      width: 100%;
      min-width: 200px;
      min-height: 160px;

      .chart-container {
        height: 100%;
        width: 100%;
        min-width: 230px;
        min-height: 150px;
        position: relative;

        .statistics-chart {
          width: 100%;
          height: 100%;
          padding: 0;
          position: relative;

          .statistics-chart-title {
            padding: 0;
            margin: 0;
          }

          .statistics-chart-value {
            padding: 0;
            margin: 0;
          }
        }
      }
    }

    .change-time:active {
      color: #54ABF1;
    }

    .time-range {
      box-sizing: border-box;
      padding-left: 20px;
      height: 30px;
      display: flex;
      align-items: center;
    }

    .amendTime {
      position: absolute;
      left: 85px;
      top: 30px;
      border: 1px solid #dddddd;
      border-radius: 5px;
      z-index: 1000;
      background: #fff;
      padding: 20px 15px 15px;

      .public-combobox-container {
        margin-bottom: 15px;
      }

      .bottom-button {
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        .el-button--mini, .el-button--mini.is-round {
          padding: 5px 15px;
        }
      }

      .el-select {
        width: 205px;
      }

      .public-select {
        width: 205px;

        .el-date-editor {
          width: 205px;

          .el-range-separator {
            width: 25px;
          }
        }
      }
    }
  }

  .chart-type-popper {
    padding: 4px 7px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/diagram.vue